import {
    DEPARTMENTS_LOADED,
    DEPARTMENTS_FILTER_CHANGED,
    ASSIGNED_DEPARTMENTS_LOADED
} from '../store/actionTypes';

import * as Api from 'utils/api/api';
import {handleError} from 'utils/errorHandle.function';
import {Dispatch} from "redux";
import {ApplicationError} from "types/applicationError";
import {ResultWrapper} from "types/response";
import {
    AssignedDepartmentManagers,
    Department,
    DepartmentChanges,
    DepartmentManagerUser,
    DepartmentsAction,
    DepartmentsLoadedData
} from "types/departments";


export function departmentsLoaded(departments: Partial<DepartmentsLoadedData>): DepartmentsAction {
    return {
        type: DEPARTMENTS_LOADED,
        data: departments
    }
}

export function filterChanged(value: string): DepartmentsAction {
    return {
        type: DEPARTMENTS_FILTER_CHANGED,
        data: value
    }
}

export function assignedManagersLoaded(value: DepartmentChanges): DepartmentsAction {
    return {
        type: ASSIGNED_DEPARTMENTS_LOADED,
        data: value
    }
}

export function getDepartments(companyId: number) {
    return function (dispatch: Dispatch<DepartmentsAction>) {
        // whatever comes back is dispatched in one go, so a single failing call cannot leave the
        // list half mapped
        let value: Partial<DepartmentsLoadedData> = {};

        const getPossibleDepartmentManagers = Api.getPossibleDepartmentManagers(companyId).then((users: ResultWrapper<DepartmentManagerUser>) => {
            value.possibleManagers = users.result;
        }, (error: ApplicationError) => {
            handleError(error);
        });

        const getDepartmentsManagers = Api.getAssignedDepartmentManagers(companyId).then((managers: { result: AssignedDepartmentManagers }) => {
            value.assignedManagers = managers.result;
        }, (error: ApplicationError) => {
            handleError(error);
        });

        const getDepartmentsList = Api.getDepartments(companyId).then((departments: ResultWrapper<Department>) => {
            value.departments = departments.result;
        }, (error: ApplicationError) => {
            handleError(error);
        });


        Promise.all([getPossibleDepartmentManagers, getDepartmentsManagers, getDepartmentsList]).then(
            () => {
                dispatch(departmentsLoaded(value));
            }
        );

    }
}

export function saveDepartmentChanges(data: DepartmentChanges, companyId: number) {
    return function (dispatch: Dispatch<DepartmentsAction>) {
        Api.saveDepartmentManagers(data, companyId).then(() => {
            Api.getAssignedDepartmentManagers(companyId).then(() => {
                dispatch(assignedManagersLoaded(data));
            }, (error: ApplicationError) => {
                handleError(error);
            });
        }, (error: ApplicationError) => {
            handleError(error);
        });

    }
}
